import styled from "styled-components";

export const HomeTopSellingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
`;
